export enum ProcessType {
  HARVESTING = 'Harvesting',
  COOLING = 'Cooling',
  INITIAL_PACKING = 'Initial Packing',
  SHIPPING = 'Shipping',
  RECEIVING = 'Receiving',
  FIRST_LAND_BASED_RECEIVER = 'First Land-Based Receiver',
  TRANSFORMATION = 'Transformation',
}

export const PROCESS_TYPE_TRANSLATION_KEYS: Record<string, string> = {
  [ProcessType.HARVESTING]: 'process-types.harvesting',
  [ProcessType.FIRST_LAND_BASED_RECEIVER]:
    'process-types.first-land-based-receiver',
  [ProcessType.COOLING]: 'process-types.cooling',
  [ProcessType.INITIAL_PACKING]: 'process-types.initial-packing',
  [ProcessType.SHIPPING]: 'process-types.shipping',
  [ProcessType.RECEIVING]: 'process-types.receiving',
  [ProcessType.TRANSFORMATION]: 'process-types.transformation',
};
